<template>
  <div class="home">

    <!-- header begin -->
        <div class="collapse bg-dark" id="navbarHeader" style="padding-bottom: 1rem;">

      <div class="container bg-dark">

        <h5 class="text-white h3" style="padding-bottom: 1rem;">Filters</h5>

        <div class="table-responsive">
          <table class="table table-sm">
            <tbody>

              <tr>
                <td class="align-middle">
                  <span class="text-white">Drink Types:</span>
                </td>
                <td>
                  <select class="custom-select" v-model="filters.drinkType" id="drinkTypeID" name="drinkType">
                    <option v-for="drinkType in drinkTypes" :key="drinkType.id" :value="drinkType.id">{{ drinkType.name }}</option>
                  </select>
                </td>
              </tr>

              <tr>
                <td class="align-middle">
                  <span class="text-white">Brew Methods:</span>
                </td>
                <td>
                  <select class="custom-select" v-model="filters.brewMethod" id="brewMethodID" name="brewMethod">
                    <option v-for="brewMethod in brewMethods" :key="brewMethod.id" :value="brewMethod.id">{{ brewMethod.name }}</option>
                  </select>
                </td>
              </tr>

              <tr>
                <td class="align-middle">
                  <span class="text-white">Roasts:</span>
                </td>
                <td>
                  <select class="custom-select" v-model="filters.roast" id="roastID" name="roast">
                    <option v-for="roast in roasts" :key="roast.id" :value="roast.id">{{ roast.name }}</option>
                  </select>
                </td>
              </tr>

              <tr>
                <td class="align-middle">
                  <span class="text-white">Coffee:</span>
                </td>
                <td>
                  <select class="custom-select" v-model="filters.coffee" id="coffeeID" name="coffee">
                    <option v-for="coffee in coffees" :key="coffee.id" :value="coffee.id">{{ coffee.name }}</option>
                  </select>
                </td>
              </tr>

              <tr>
                <td class="align-middle">
                  <span class="text-white">Strengths:</span>
                </td>
                <td>
                  <select class="custom-select" v-model="filters.strength" id="strengthID" name="strength">
                    <option v-for="strength in strengths" :key="strength.id" :value="strength.id">{{ strength.name }}</option>
                  </select>
                </td>
              </tr>
              
            </tbody>
          </table>

          <button type="button" v-on:click="filterDrinks" class="btn btn-light btn-sm">Apply</button>

        </div>

      </div>
    </div>

    <div class="navbar navbar-dark bg-dark box-shadow">
      <div class="container d-flex justify-content-between">
        <a href="#" class="navbar-brand d-flex align-items-center">
          <img src="../assets/small_logo.png" alt="logo" height="32" style="padding-right: 8px;" />
          <strong>VALL HOUSE COFFEE</strong>
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarHeader" aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
      </div>
    </div>
    <!-- header end -->

    <!-- menu start -->
    <div class="container bg-light"  style="padding-top: 1rem;">

      <!-- <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link" v-bind:class="{ active: simpleMenu }" v-on:click="showSimpleMenu" href="#">Simplified</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-bind:class="{ active: !simpleMenu }" v-on:click="showAdvancedMenu" href="#">Advanced</a>
        </li>
      </ul> -->

      <template v-if="loading">
        <div class="row">
          <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div>
      </template>

      <template v-if="!loading && drinks.length === 0">
        <div class="row">
          <p class="card-text">No matching entries found.</p>
        </div>
      </template>

      <template v-if="!loading && drinks.length > 0">
        <div class="row">
          <div class="col-md-4" v-for="drink in drinks" :key="drink.id">
            <div class="card mb-4 box-shadow">
              
              <img v-if="drink.image !== undefined" class="card-img-top" alt="Drink Thumbnail [100%x225]" style="width: 100%; display: block;" :src="drink.image">
              <img v-else class="card-img-top" data-src="holder.js/100px225?theme=thumb&amp;bg=55595c&amp;fg=eceeef&amp;text=Thumbnail" alt="Thumbnail [100%x225]" style="height: 225px; width: 100%; display: block;" src="data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22348%22%20height%3D%22225%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20348%20225%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_164a09aec6a%20text%20%7B%20fill%3A%23eceeef%3Bfont-weight%3Abold%3Bfont-family%3AArial%2C%20Helvetica%2C%20Open%20Sans%2C%20sans-serif%2C%20monospace%3Bfont-size%3A17pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_164a09aec6a%22%3E%3Crect%20width%3D%22348%22%20height%3D%22225%22%20fill%3D%22%2355595c%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%22116.234375%22%20y%3D%22120.3%22%3EThumbnail%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E" data-holder-rendered="true">

              <div class="card-body">
                <h3>{{ drink.name }}</h3>
                <p class="card-text">{{ drink.description }}</p>

                <p class="card-text">

                  <div class="table-responsive">
                    <table class="table table-sm">
                      <tbody>
                          <template v-if="drink.coffee !== undefined">
                            <tr><td>Coffee:</td><td>{{ drink.coffee }}</td></tr>
                          </template>
                          <template v-if="drink.roast !== undefined">
                            <tr><td>Roast:</td><td>{{ drink.roast }}</td></tr>
                          </template>
                          <template v-if="drink.drinkType !== undefined">
                            <tr><td>Type:</td><td>{{ drink.drinkType }}</td></tr>
                          </template>
                          <template v-if="drink.brewMethod !== undefined">
                            <tr><td>Method:</td><td>{{ drink.brewMethod }}</td></tr>
                          </template>
                          <tr><td>Strength:</td><td>{{ drink.strength }}</td></tr>
                      </tbody>
                    </table>
                  </div>

                </p>

                <div class="d-flex justify-content-between align-items-center">
                  <div class="btn-group">
                    <!--button type="button" class="btn btn-sm btn-outline-secondary">View</button>
                    <button type="button" class="btn btn-sm btn-outline-secondary">Edit</button>
                    <button type="button" class="btn btn-sm btn-outline-secondary">Order</button-->
                  </div>
                  <small class="text-muted"></small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <!-- menu start -->

  </div>
</template>

<style scoped>
.lds-spinner {
  color: official;
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-spinner div {
  transform-origin: 32px 32px;
  animation: lds-spinner 1.2s linear infinite;
}
.lds-spinner div:after {
  content: " ";
  display: block;
  position: absolute;
  top: 3px;
  left: 29px;
  width: 5px;
  height: 14px;
  border-radius: 20%;
  background: #343a40;
}
.lds-spinner div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}
.lds-spinner div:nth-child(2) {
  transform: rotate(30deg);
  animation-delay: -1s;
}
.lds-spinner div:nth-child(3) {
  transform: rotate(60deg);
  animation-delay: -0.9s;
}
.lds-spinner div:nth-child(4) {
  transform: rotate(90deg);
  animation-delay: -0.8s;
}
.lds-spinner div:nth-child(5) {
  transform: rotate(120deg);
  animation-delay: -0.7s;
}
.lds-spinner div:nth-child(6) {
  transform: rotate(150deg);
  animation-delay: -0.6s;
}
.lds-spinner div:nth-child(7) {
  transform: rotate(180deg);
  animation-delay: -0.5s;
}
.lds-spinner div:nth-child(8) {
  transform: rotate(210deg);
  animation-delay: -0.4s;
}
.lds-spinner div:nth-child(9) {
  transform: rotate(240deg);
  animation-delay: -0.3s;
}
.lds-spinner div:nth-child(10) {
  transform: rotate(270deg);
  animation-delay: -0.2s;
}
.lds-spinner div:nth-child(11) {
  transform: rotate(300deg);
  animation-delay: -0.1s;
}
.lds-spinner div:nth-child(12) {
  transform: rotate(330deg);
  animation-delay: 0s;
}
@keyframes lds-spinner {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>


<script>
import DrinkTypeService from '@/services/DrinkTypeService'
import BrewMethodService from '@/services/BrewMethodService'
import RoastService from '@/services/RoastService'
import CoffeeService from '@/services/CoffeeService'
import StrengthService from '@/services/StrengthService'
import DrinkService from '@/services/DrinkService'

export default {
  name: 'home',
  data: function() {
    return {
      loading: true,
      simpleMenu: true,
      drinks: [],
      drinkTypes: [],
      brewMethods: [],
      roasts: [],
      coffees: [],
      strengths: [],
      filters: {
        drinkType: 0,
        brewMethod: 0,
        roast: 0,
        coffee: 0,
        strength: 0
      }
    }
  },
  created: function() {
    DrinkTypeService.getDrinkTypes()
      .then(_drinkTypes => {
        _drinkTypes.unshift({ 'id': 0, 'name': 'All' })
        this.drinkTypes = _drinkTypes
      })
      .catch(error => {
      })
      .finally(() => {
      })

    BrewMethodService.getBrewMethods()
      .then(_brewMethods => {
        _brewMethods.unshift({ 'id': 0, 'name': 'All' })
        this.brewMethods = _brewMethods
      })
      .catch(error => {
      })
      .finally(() => {
      })

    RoastService.getRoasts()
      .then(_roasts => {
        _roasts.unshift({ 'id': 0, 'name': 'All' })
        this.roasts = _roasts
      })
      .catch(error => {
      })
      .finally(() => {
      })

    CoffeeService.getCoffees()
      .then(_coffees => {
        _coffees.unshift({ 'id': 0, 'name': 'All' })
        this.coffees = _coffees
      })
      .catch(error => {
      })
      .finally(() => {
      })

    StrengthService.getStrengths()
      .then(_strengths => {
        _strengths.unshift({ 'id': 0, 'name': 'All' })
        this.strengths = _strengths
      })
      .catch(error => {
      })
      .finally(() => {
      })

      DrinkService.getDrinks(this.simpleMenu)
        .then(_drinks => {
          this.drinks = _drinks;
        })
        .catch(error => {
        })
        .finally(() => {
          this.loading = false
        })
  },
  methods: {
    filterDrinks: function(event) {
      this.loading = true
      DrinkService.getFDrinks(this.simpleMenu, this.filters.drinkType, this.filters.brewMethod, this.filters.roast, this.filters.coffee, this.filters.strength)
        .then(_drinks => {
          this.drinks = _drinks
        })
        .catch(error => {
        })
        .finally(() => {
          this.loading = false
        })
    },
    showSimpleMenu: function(event) {
      this.simpleMenu = true

      this.loading = true
      DrinkService.getFDrinks(this.simpleMenu, this.filters.drinkType, this.filters.brewMethod, this.filters.roast, this.filters.coffee, this.filters.strength)
        .then(_drinks => {
          this.drinks = _drinks
        })
        .catch(error => {
        })
        .finally(() => {
          this.loading = false
        })
    },
    showAdvancedMenu: function(event) {
      this.simpleMenu = false

      this.loading = true
      DrinkService.getFDrinks(this.simpleMenu, this.filters.drinkType, this.filters.brewMethod, this.filters.roast, this.filters.coffee, this.filters.strength)
        .then(_drinks => {
          this.drinks = _drinks
        })
        .catch(error => {
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
